module.exports = __webpack_public_path__ + "img/midwest-fall-1920x550.28578430.jpg";